export const HEADER_SEARCH_VERSION_STORAGE_KEY = "headerSearchVersion";
export const SEARCH_QUERY_ID_STORAGE_KEY = "search_query_id";
